(function () {
    const states = ["#category_id"];

    for (let i = 0; i < states.length; i++) {
        var state = $(states[i]);
        state.change(function () {
            getcities($(this));
        });
        state.change();
    }

    function getcities(state) {
        const city_selec = state.attr('subsystem_select');
        const city_name = "#" + state.attr('subsystem_id');


        if (state.val() == null || state.val() == '' && $(city_name).length > 1) {
            $(city_name).empty();
            return;
        }

        $.ajax({
            url: URL("condominio/preventive_maintenances/select_subcateory/" + (state.val() == 0 ? "0" : state.val())),
            type: 'get',
            beforeSend: function () { },
            success: function (result) {

                $(city_name).empty();
                $(city_name).append(new Option("Todos", ''));
                result.data.forEach(function (city) {
                    if (city_selec != null && city_selec == city.id) {
                        $(city_name).append(new Option(city.name, city.id, false, true));
                    } else {
                        $(city_name).append(new Option(city.name, city.id));
                    }
                });
                $(city_name).change();

            },
            error: function (err) {
                console.log(err);
            }
        });
    }

})();

function URL(urlpath) {
    let url = "";
    url += window.location.protocol + "//";
    url += window.location.hostname;
    const porta = window.location.href
        .replace(window.location.protocol + "//", '')
        .replace(window.location.pathname, '')
        .replace(window.location.hostname, '')
        .replace(":", "");

    if (!isNaN(porta)) {
        url += ":" + porta;
    }
    if (urlpath.charAt(0) == '/') {
        return url + urlpath;
    } else {
        return url + "/" + urlpath;
    }
}
